import React, { Component } from 'react'
import * as R from 'ramda'

import CalcTooltip from 'components/CalcTooltip'

export default class TooltipContent extends Component{
	render(){
		let { props } = this
		return(
			props.data.calc ?
				<CalcTooltip data={props.data.calc} close={props.close}/>
				:
				<div style={{display: "inline-block"}}>
					<div style={{float: "left"}}>
						{
							props.data.hint ?
								props.data.hint
								:
								R.values(R.mapObjIndexed((value, key) => (
									<div
										style={{
											display: 'flex'
										  , justifyContent: 'space-between'
										  , marginTop: "10px"
										  , fontSize: "12px"
										}}
									>
										<div style={{textTransform: "capitalize", marginRight: "30px"}}>
											{key}
										</div>
										<div>
											{value}
										</div>
									</div>
								))(props.data))
						}
					</div>
					<div
						style={{textAlign: "right", cursor: "pointer", float: "right", marginLeft: "10px"}}
						onClick={props.close}
					>
						<i className="material-icons" style={{fontSize: "18px", color: "rgba(255, 255, 255, 0.4)"}}>clear</i>
					</div>
				</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/TooltipContent.js